import CustomCard from '@/components/customCard';
import UpgradeTextWithTouchPoint from '@/components/UpgradeTextWithTouchPoint';
import { BREAKPOINT, Touchpoint } from '@/constants/enum';
import useUserPlan from '@/hooks/useUserPlan';
import settingsSlice, { dataSettingsSelector } from '@/redux/slice/settings.slice';
import Editor from '@monaco-editor/react';
import { memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useMediaQuery } from 'react-responsive';

const CustomCss = () => {
  const dispatch = useDispatch();
  const isMobile = useMediaQuery({ maxWidth: BREAKPOINT.XS });
  const { planKey, isFreePlan } = useUserPlan();
  const isDisabled = planKey === 'free';
  const dataSettings = useSelector(dataSettingsSelector);

  return (
    <CustomCard
      title={<span className={`text--lg ${isFreePlan ? 'text--gray' : ''}`}>Custom CSS</span>}
      titleContentRight={
        !isMobile ? (
          <div className="min-w-fit">
            <UpgradeTextWithTouchPoint touchPoint={Touchpoint.CustomCSS} text="Standard or above" />
          </div>
        ) : undefined
      }
    >
      {isMobile && <UpgradeTextWithTouchPoint touchPoint={Touchpoint.CustomCSS} text="Standard or above" />}
      <Editor
        className={`mt-8 ${isDisabled ? 'disable-content' : ''}`}
        onChange={(value) => {
          if (!isDisabled) {
            dispatch(
              settingsSlice.actions.handleDataSettings({
                ...dataSettings,
                custom_css: value || '',
              }),
            );
          }
        }}
        height="24rem"
        theme="vs-dark"
        value={dataSettings.custom_css}
        language="css"
      />
    </CustomCard>
  );
};
export default memo(CustomCss);
